import React, {
  forwardRef,
  useImperativeHandle,
  useState,
  useEffect,
} from 'react';
import { Card, Button, Row, Col, Input, Spin } from 'antd';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import DeviceStore from 'stores/Classes/DeviceStore';
import { DeleteOutlined, PlusCircleOutlined } from '@ant-design/icons';

const StyledCard = styled(Card)`
  & {
    width: 100%;
    min-height: 110px;
  }

  .title {
    margin-bottom: 12px;
  }

  .ant-card-body {
    padding: 12px 12px 24px;
  }

  .ant-btn {
    padding: 0;
  }

  .component {
    margin-bottom: 12px;

    label {
      display: block;
      font-weight: bold;
      font-size: 13px;
      margin-bottom: 2px;
    }
  }
`;

const AddWarrantyComponent = forwardRef(
  ({ initialComponents = [], isLoadingComponents = false }, ref) => {
    const [components, setComponents] = useState([...initialComponents]);
    const { device } = DeviceStore;

    useEffect(() => {
      if (components.length === 0) {
        setComponents([...initialComponents]);
      }
    }, [initialComponents]);

    useImperativeHandle(ref, () => ({
      getComponents: () => components,
      clearComponents: () => setComponents([]),
    }));

    const handleAddComponent = () => {
      setComponents([
        ...components,
        {
          name: '',
          description: '',
        },
      ]);
    };

    const handleComponentChange = (index, field, value) => {
      const newComponents = [...components];
      newComponents[index][field] = value;
      setComponents(newComponents);
    };

    const handleDeleteComponent = (index) => {
      const newComponents = [...components];
      newComponents.splice(index, 1);
      setComponents(newComponents);
    };

    return (
      <Spin spinning={isLoadingComponents}>
        <StyledCard>
          <div className="title">
            <b>Add Components:</b>
          </div>
          {components.map((component, index) => (
            <Row
              key={index}
              className="component"
              gutter={16}
              type={device !== 'desktop' ? 'flex' : undefined}
              direction={device !== 'desktop' ? 'vertical' : 'horizontal'}
            >
              <Col span={11}>
                <label htmlFor={`componentName-${index}`}>
                  Component Name:
                </label>
                <Input
                  id={`componentName-${index}`}
                  value={component.name}
                  onChange={(e) =>
                    handleComponentChange(index, 'name', e.target.value)
                  }
                />
              </Col>
              <Col span={11}>
                <label htmlFor={`componentDescription-${index}`}>
                  Component Description:
                </label>
                <Input
                  id={`componentDescription-${index}`}
                  value={component.description}
                  onChange={(e) =>
                    handleComponentChange(index, 'description', e.target.value)
                  }
                />
              </Col>
              <Col
                span={2}
                style={{
                  position: 'relative',
                }}
              >
                <Button
                  type="text"
                  onClick={() => handleDeleteComponent(index)}
                  style={{
                    position: 'absolute',
                    top: '20px',
                    color: '#757575',
                  }}
                >
                  <DeleteOutlined />
                </Button>
              </Col>
            </Row>
          ))}
          <Button
            type="text"
            onClick={handleAddComponent}
            style={{ color: '#1677ff' }}
          >
            <PlusCircleOutlined />
            Add Component
          </Button>
        </StyledCard>
      </Spin>
    );
  }
);

AddWarrantyComponent.propTypes = {
  initialComponents: PropTypes.array,
  isLoadingComponents: PropTypes.bool,
};

export default AddWarrantyComponent;
